module.exports = __webpack_public_path__ + "img/baseInfo_icon5.f89c7643.svg";